<template>
	<v-dialog v-model="dialog" :max-width="maxWidth" :overlay-opacity="overlayOpacity">
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				:text="openBtnDesign.includes('text') ? true : false"
				:outlined="openBtnDesign.includes('outlined') ? true : false"
				:color="openBtnColor"
				:style="openBtnStyle"
				@click.stop="dialog = true"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-1">mdi-plus</v-icon>
				<slot name="btn-text"> 作成する </slot>
			</v-btn>
		</template>
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">確認 </v-app-bar-title>
				<v-spacer />
				<v-btn v-if="$vuetify.breakpoint.xs" @click=";(dialog = false), (errors = [])" icon>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<ValidationError :errors="errors" />
			<v-card-text class="pa-2" color="black">
				製品情報が新しく作成されます<br />
				現在表示されている製品情報のステータスを選択してください<br />
				<v-select
					v-model="change_status"
					label="ステータス"
					class="mt-4"
					outlined
					dense
					:items="statuses"
					item-text="name"
					item-value="value"
					hint="ステータスを選択してください"
				>
				</v-select>
			</v-card-text>

			<v-card-actions>
				<v-row no-gutters justify="center">
					<v-col sm="2" cols="0" />
					<v-col sm="8" cols="12">
						<slot name="button">
							<v-row justify="center">
								<v-btn
									class="ma-1"
									@click="createProduct"
									:disabled="!isValid"
									dense
									color="secondary"
								>
									<v-icon class="mr-1">mdi-plus</v-icon>

									{{ createBtnText }}</v-btn
								>
							</v-row>
						</slot>
					</v-col>
					<v-col sm="2" cols="0">
						<v-row no-gutters align="center">
							<v-spacer></v-spacer>
							<v-btn
								v-if="!$vuetify.breakpoint.xs"
								color="grey darken-1"
								text
								@click=";(dialog = false), (errors = [])"
							>
								キャンセル
							</v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import ValidationError from "../../shared/ValidationError.vue"

export default {
	components: {
		ValidationError,
	},
	props: {
		id: {
			type: [Number, String],
			required: true,
		},
		product: {
			type: Object,
			required: true,
			default: () => {},
		},
		statuses: {
			type: Array,
			required: true,
			default: () => [],
		},
		// ダイアログ外部分Opacity
		overlayOpacity: {
			type: String,
			default: "0.7",
			required: false,
		},
		// ダイアログを開くボタンのデザインを配列で受け取る
		openBtnDesign: {
			type: Array,
			default: () => [],
			required: false,
		},
		// ダイアログを開くボタンの色
		openBtnColor: {
			type: String,
			default: "secondary",
			required: false,
		},
		// ダイアログを開くボタンのStyleを受け取る。
		openBtnStyle: {
			type: Object,
			default: null,
			required: false,
		},
		// ダイアログのmax-width
		maxWidth: {
			type: String,
			default: "700px",
			required: false,
		},
		// 作成メソッドが呼び出されるボタンのテキスト
		createBtnText: {
			type: String,
			required: false,
			default: "作成する",
		},
	},
	data() {
		return {
			dialog: false,
			change_status: "",
			errors: [],
		}
	},
	methods: {
		closeDialog() {
			this.dialog = false
		},
		createProduct() {
			const headers = authenticate.setHeader()

			axios
				.post(
					"/erp/v1/products",
					{
						product: {
							name: this.product.name,
							product_code: this.product.product_code,
							standard_price: this.product.standard_price,
							list_price: this.product.list_price,
							cost_price: this.product.cost_price,
							specification: this.product.specification,
							product_category_id: this.product.product_category_id,
							product_sub_category_id: this.product.product_sub_category_id,
							wildcard: this.product.wildcard,
							product_code_prefix_id: this.product.product_code_prefix_id,
						},
						renewal: { change_status: this.change_status, id: this.id },
					},
					{
						headers,
					}
				)
				.then((res) => {
					this.$store.commit("setFlash", {
						type: "notice",
						text: "製品を作成しました。",
					})
					this.closeDialog()
					this.$router.push({ name: "product_show", params: { id: res.data.product.id } })
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
					const errors = err.response.data.errors
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
	},
	computed: {
		isValid() {
			return this.change_status !== null && this.change_status !== ""
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";

.v-card {
	@media (max-width: $xs) {
		padding-bottom: 10px;
	}
}
</style>
